import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SocialMedia from "../../components/socialMedia";
import InstallAppCard from "../../components/InstallButton";
import "./style.min.css";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <footer
      className="relative w-full bg-cover  rounded-t-[40px] text-[var(--body_color)] footer-with-subtle-bg"
      style={{ backgroundImage: "var(--footer)" }}
      dir={lang === "ar" ? "rtl" : "ltr"}
    >
      {/* CTA Section */}
      <div className="max-w-6xl mx-auto px-6 py-16 lg:py-20 grid md:grid-cols-2 gap-12 items-center z-10 relative">
        <div>
          <h2 className="text-4xl font-extrabold mb-4 leading-tight gradient-text">
            {t("footer.cta_title")}
          </h2>

          <p className="text-lg text-[var(--body_color)] max-w-xl">
            {t("footer.cta_subtitle")}
          </p>

          <div className="flex gap-4 mt-8 flex-wrap">
            <Link to="/quote" className="btn-primary">
              {t("footer.cta_quote")}
            </Link>
            <Link to="/contact" className="btn-secondary">
              {t("footer.cta_email")}
            </Link>
          </div>
        </div>

        <div className="hidden md:block" />
      </div>

      {/* Install App Section */}
      <div className="max-w-6xl mx-auto px-6 pb-10 relative z-10">
        <div className="install-app-wrapper">
          <InstallAppCard />
        </div>
      </div>

      {/* Links Section */}
      <div className="footer-links  relative">
        <div className="max-w-6xl mx-auto px-6 py-6 grid gap-10 sm:grid-cols-2 md:grid-cols-4 text-sm">
          <div>
            <h3 className="section-title">{t("footer.identity_title")}</h3>
            <p>{t("footer.identity_desc")}</p>
          </div>

          <div>
            <h3 className="section-title">{t("footer.services_title")}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/full-stack-freelance">Full Stack freelance</Link>
              </li>
              <li>
                <Link to="/creation-site-web">Création site web</Link>
              </li>
              <li>
                <Link to="/developpement-saas">Développement SaaS</Link>
              </li>
              <li>
                <Link to="/audit-seo-technique">SEO technique</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="section-title">{t("footer.menu_title")}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services">{t("footer.menu_about")}</Link>
              </li>
              <li>
                <Link to="/portfolio">{t("footer.menu_projects")}</Link>
              </li>
              <li>
                <Link to="/contact">{t("footer.menu_contact")}</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="section-title">Social</h3>
            <div className="social-row">
              <SocialMedia />
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center py-6 text-xs text-[var(--body_color)] border-t border-black/5 dark:border-white/5 z-10 relative">
        © {new Date().getFullYear()} {t("footer.copyright")}
      </div>
    </footer>
  );
};

export default Footer;
